"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AsOfDate = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importStar(require("react"));
var styled_components_1 = tslib_1.__importDefault(require("styled-components"));
var Components_1 = require("../../../Components");
var Classification_helpers_1 = require("../Classification.helpers");
exports.AsOfDate = function (_a) {
    var onDateChange = _a.onDateChange, dateOptions = _a.dateOptions, dateValue = _a.dateValue;
    var _b = react_1.useState([]), sortedOptions = _b[0], setDateOptions = _b[1];
    react_1.useEffect(function () {
        var sorted = Classification_helpers_1.sortedDateOptions(dateOptions || []);
        setDateOptions(sorted);
    }, [dateOptions]);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(StyledSelect, { value: dateValue, onChange: function (value) {
                onDateChange === null || onDateChange === void 0 ? void 0 : onDateChange(value);
            }, placeholder: "None", options: sortedOptions, isDisabled: dateOptions && (dateOptions === null || dateOptions === void 0 ? void 0 : dateOptions.length) <= 0 })));
};
var StyledSelect = styled_components_1.default(Components_1.Select)(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n  width: 300px;\n"], ["\n  width: 300px;\n"])));
var templateObject_1;
